export default __webpack_public_path__ + "static/media/BRALogo2.ee67cac4.jpg";